import { makeStyles } from '@material-ui/core/styles';
import { Block } from '@material-ui/icons';

const black = '#000';
const white = '#fff';
const lightGray = '#C2C2C2';
const darkGray = '#929292';
const bgColor = '#fafafa';

const useStyles = makeStyles((theme) => ({
    loginMessage: {
        width: '310px',
        margin: '0 auto',
        color: lightGray,
        '& p': {
            fontSize: '14px',
            fontWeight: 'bold',
            textAlign: 'center',
            margin: '36px auto 0',
            backgroundColor: bgColor,
            '& span': {
                color: '#000'
            }
        }
    },
    tabsContainer: {
        width: '310px',
        margin: '36px auto 0',
        '& .MuiTabs-flexContainer': {
            margin: '0 3px',
            display: 'flex',
            justifyContent: 'space-between',
        },
        '& .MuiTabs-indicator': {
            display: 'none'
        }
    },
    tab: {
        width: '151px',
        height: '48px',
        marginBottom: '24px',
        fontWeight: 'bold',
        borderRadius: '34px',
        '&.Mui-selected': {
            backgroundColor: '#fff',
            boxShadow: '1px 3px 6px 0 rgb(0 0 0 / 7%) !important'
        },
        '&.MuiTab-root': {
            [theme.breakpoints.up('768')]: {
                minWidth: '121px'
            },
        }
    },
    continueBtn: {
        marginLeft: 'auto',
        marginBottom: '24px'
    },
    loginError: {
        display: 'block',
        marginBottom: '10px',
        marginTop: 0,
        color: 'red'
    }
}));

export { useStyles };